import { render, staticRenderFns } from "./LocationsAutocomplete.vue?vue&type=template&id=36d5b3a8&"
import script from "./LocationsAutocomplete.vue?vue&type=script&lang=js&"
export * from "./LocationsAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36d5b3a8')) {
      api.createRecord('36d5b3a8', component.options)
    } else {
      api.reload('36d5b3a8', component.options)
    }
    module.hot.accept("./LocationsAutocomplete.vue?vue&type=template&id=36d5b3a8&", function () {
      api.rerender('36d5b3a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/LocationsAutocomplete.vue"
export default component.exports